// @ts-nocheck
import { useExpenseRepository } from '../repositories';
// TODO: Individual expense CRUD, submit/approve/reject workflows, and
// report-level operations are specialized and not fully covered by the
// Expense repository's CRUD. Remove compat imports once the repository
// supports these operations.
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  EXPENSES_QUERY,
  EXPENSE_QUERY,
  CREATE_EXPENSE_MUTATION,
  UPDATE_EXPENSE_MUTATION,
  SUBMIT_EXPENSE_MUTATION,
  APPROVE_EXPENSE_MUTATION,
  REJECT_EXPENSE_MUTATION,
  EXPENSE_REPORTS_QUERY,
  SUBMIT_EXPENSE_REPORT_MUTATION,
  APPROVE_EXPENSE_REPORT_MUTATION,
  REJECT_EXPENSE_REPORT_MUTATION,
  ADD_EXPENSE_TO_REPORT_MUTATION,
} from '../graphql/operations';
import type {
  Expense,
  ExpenseReport,
  CreateExpenseInput,
  UpdateExpenseInput,
  CreateExpenseReportInput,
} from '../types/expense';

// ── Hooks: Expenses ───────────────────────────────────────────────────

// TODO: Migrate to repository pattern once an individual Expense repository exists.
// The current ExpenseRepository covers ExpenseReports, not individual expenses.
export function useExpenses(variables?: {
  page?: number;
  perPage?: number;
  status?: string;
  employeeId?: string;
  category?: string;
}) {
  return useCompatQuery(EXPENSES_QUERY, { variables });
}

// TODO: Migrate to repository pattern once an individual Expense repository exists.
export function useExpense(id: string) {
  return useCompatQuery(EXPENSE_QUERY, {
    variables: { id },
    skip: !id,
  });
}

// TODO: Migrate to repository pattern once an individual Expense repository exists.
export function useCreateExpense() {
  return useCompatMutation(CREATE_EXPENSE_MUTATION, {
    refetchQueries: [{ query: EXPENSES_QUERY }],
  });
}

// TODO: Migrate to repository pattern once an individual Expense repository exists.
export function useUpdateExpense() {
  return useCompatMutation(UPDATE_EXPENSE_MUTATION, {
    refetchQueries: [{ query: EXPENSES_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useSubmitExpense() {
  return useCompatMutation(SUBMIT_EXPENSE_MUTATION, {
    refetchQueries: [{ query: EXPENSES_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useApproveExpense() {
  return useCompatMutation(APPROVE_EXPENSE_MUTATION, {
    refetchQueries: [
      { query: EXPENSES_QUERY },
      { query: EXPENSE_REPORTS_QUERY },
    ],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useRejectExpense() {
  return useCompatMutation(REJECT_EXPENSE_MUTATION, {
    refetchQueries: [
      { query: EXPENSES_QUERY },
      { query: EXPENSE_REPORTS_QUERY },
    ],
  });
}

// ── Hooks: Expense Reports ────────────────────────────────────────────

export function useExpenseReports(variables?: {
  page?: number;
  perPage?: number;
  employeeId?: string;
  status?: string;
}) {
  const repo = useExpenseRepository();
  return repo.useList(variables);
}

export function useExpenseReport(id: string) {
  const repo = useExpenseRepository();
  return repo.useGet(id);
}

export function useCreateExpenseReport() {
  const repo = useExpenseRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useSubmitExpenseReport() {
  return useCompatMutation(SUBMIT_EXPENSE_REPORT_MUTATION, {
    refetchQueries: [{ query: EXPENSE_REPORTS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useApproveExpenseReport() {
  return useCompatMutation(APPROVE_EXPENSE_REPORT_MUTATION, {
    refetchQueries: [
      { query: EXPENSE_REPORTS_QUERY },
      { query: EXPENSES_QUERY },
    ],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useRejectExpenseReport() {
  return useCompatMutation(REJECT_EXPENSE_REPORT_MUTATION, {
    refetchQueries: [{ query: EXPENSE_REPORTS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useAddExpenseToReport() {
  return useCompatMutation(ADD_EXPENSE_TO_REPORT_MUTATION, {
    refetchQueries: [
      { query: EXPENSE_REPORTS_QUERY },
      { query: EXPENSES_QUERY },
    ],
  });
}
